import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=484fb63b&scoped=true"
import script from "./Articles.vue?vue&type=script&setup=true&lang=js"
export * from "./Articles.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Articles.vue?vue&type=style&index=0&id=484fb63b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484fb63b",
  null
  
)

export default component.exports